"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isBoolean = _interopRequireDefault(require("../object/isBoolean"));

var _isEmpty = _interopRequireDefault(require("../object/isEmpty"));

var _creative = require("../../constants/creative");

var isVisible = function isVisible(content) {
  if ((0, _isEmpty["default"])(content)) return false;
  var contentType = content.contentType,
      visible = content.visible; // if property 'visible' doesn't exist, we assume that it IS visible
  // we only that the assumption if the layer is not an audio layer

  var undefinedVisibility = !(0, _isBoolean["default"])(visible);
  var defaultVisible = undefinedVisibility && !_creative.INVISIBLE_CONTENT_TYPES.has(contentType);
  return defaultVisible || visible;
};

var _default = isVisible;
exports["default"] = _default;